var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":_vm.colour,"dense":"","title":_vm.title}},[_vm._v("mdi-cloud-sync-outline")])
}
var staticRenderFns = []

export { render, staticRenderFns }